import styled from 'styled-components';
import { theme } from '../../theme/theme';

export const Icon = styled.div<{
	$colorFill?: keyof typeof theme;
	$colorStroke?: keyof typeof theme;
	$colorFillHover?: keyof typeof theme;
	$colorStrokeHover?: keyof typeof theme;
}>`
	display: flex;
	> svg {
		width: auto;
		height: 100%;
		${({ theme, $colorFill }) => ($colorFill ? `fill: ${theme[$colorFill]};` : '')}
		${({ theme, $colorStroke }) => ($colorStroke ? `stroke: ${theme[$colorStroke]};` : '')}
	}
	&:hover {
		> svg {
			${({ theme, $colorFillHover }) => ($colorFillHover ? `fill: ${theme[$colorFillHover]};` : '')}
			${({ theme, $colorStrokeHover }) => ($colorStrokeHover ? `stroke: ${theme[$colorStrokeHover]};` : '')}
		}
	}
`;

export const IconButton = styled.button<{
	$colorFill?: keyof typeof theme;
	$colorStroke?: keyof typeof theme;
	$colorFillHover?: keyof typeof theme;
	$colorStrokeHover?: keyof typeof theme;
}>`
	background: transparent;
	padding: 0;
	outline: none;
	border: none;
	&:disabled {
		opacity: 0.4;
		cursor: not-allowed !important;
		&:hover > svg {
			${({ theme, $colorFill }) => ($colorFill ? `fill: ${theme[$colorFill]};` : '')}
			${({ theme, $colorStroke }) => ($colorStroke ? `stroke: ${theme[$colorStroke]};` : '')}
		}
	}
	> svg {
		width: auto;
		height: 100%;
		${({ theme, $colorFill }) => ($colorFill ? `fill: ${theme[$colorFill]};` : '')}
		${({ theme, $colorStroke }) => ($colorStroke ? `stroke: ${theme[$colorStroke]};` : '')}
	}
	&:hover {
		> svg {
			${({ theme, $colorFillHover }) => ($colorFillHover ? `fill: ${theme[$colorFillHover]};` : '')}
			${({ theme, $colorStrokeHover }) => ($colorStrokeHover ? `stroke: ${theme[$colorStrokeHover]};` : '')}
		}
	}
`;
